<template>
    <Modal :showTitle="false" :showFooter="false" :class-name="'visitor-detail-popup'" @cancel="closePopup">
        <VisitorDetail :visitorId="visitorDetailPopup" :visibleMail="visibleMail" @detailClose="detailClose" />
    </Modal>
</template>
<script>
import Modal from "../../../components/common/Modal2.vue";
import { mapActions, mapState } from "vuex";
import VisitorDetail from "./VisitorDetail";

export default {
    props: {
        visibleMail: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {},
    components: {
        Modal,
        VisitorDetail,
    },
    computed: {
        ...mapState({
            visitorDetailPopup: (state) => state.app.visitorDetailPopup,
        }),
    },
    methods: {
        ...mapActions({
            setVisitorDetailPopup: "app/setVisitorDetailPopup",
        }),
        detailClose() {
            this.closePopup();
        },
        closePopup() {
            this.setVisitorDetailPopup(false);
        },
    },
};
</script>
<style lang="scss">
.visitor-detail-popup {
    z-index: 1000 !important;
    background: #00000091;
    overflow-y: auto;

    & #visitor-detail {
        width: 100% !important;

        .supsis-tab-selection {
            width: 100% !important;
        }
    }

    .ant-modal {
        width: 70% !important;
        top: 0;
    }

    .ant-modal-content {
        display: flex;
        flex-direction: column;
        height: calc(90vh);
        margin-top: 10px;
    }

    .custom-modal-body {
        padding: 0 !important;
        margin-bottom: 10px;
    }
}
</style>
